import { autoinject } from 'aurelia-dependency-injection';
import { CustomerSettings } from '../classes/customer-settings';
import { CategoriesClient, CategoryViewModel } from '@dynamik/common/clients/transaction-clients';
import { CacheService } from '@dynamik/common';

@autoinject
export class TransactionCategoriesCache {
  constructor(private categoriesClient: CategoriesClient, private customerSettings: CustomerSettings, private cacheService: CacheService) { }

  data: Promise<CategoryViewModel[]>;
  companyIdentityId: number;

  async get() {
    return this.cacheService.getOrSet(`transaction-categories-${this.customerSettings.selectedCustomer.companyId}`,
      () => this.categoriesClient.transactionCategories(this.customerSettings.selectedCustomer.companyId), 6000000000);
  }
}
